export default __webpack_public_path__ + "static/media/README.06af353e.md";